const publicMethods = {
  format(value) {
    //为了兼容ie9时间格式
    if (value) {
      var tt = value.replace(/-/g, "/");
      var time = new Date(tt);
      return time;
    } else {
      return "";
    }
  },
  formatDate: function(time) {
    var now = this.format(time);
    var year = now.getFullYear();
    var month = now.getMonth() + 1;
    var date = now.getDate();
    var hour = now.getHours();
    var minute = now.getMinutes();
    var second = now.getSeconds();
    return (
      year +
      "-" +
      this.add0(month) +
      "-" +
      this.add0(date) +
      " " +
      this.add0(hour) +
      ":" +
      this.add0(minute) +
      ":" +
      this.add0(second)
    );
  },
  add0: function(v) {
    var a = v < 10 ? "0" + v : v;
    return a;
  },
  getPoint: function(obj) {
    //获取某元素以浏览器左上角为原点的坐标
    var t = obj.offsetTop; //获取该元素对应父容器的上边距
    var l = obj.offsetLeft; //对应父容器的上边距
    //判断是否有父容器，如果存在则累加其边距
    while ((obj = obj.offsetParent)) {
      //等效 obj = obj.offsetParent;while (obj != undefined)
      t += obj.offsetTop; //叠加父容器的上边距
      l += obj.offsetLeft; //叠加父容器的左边距
    }
    return {
      t: t,
      l: l
    };
  },
  formatTime(value) {
    //为了兼容ie9时间格式
    if (value) {
      var tt = value.replace(/-/g, "/");
      var time = new Date(tt);
      return time;
    } else {
      return "";
    }
  }
};

export default publicMethods;
